import { pushNotification } from "../../pushNotification";

export function aiCodeMetrics(args) {
  const { token, sourceCodeDownloadPath } = args || {};

  const downloadFile = async (url, defaultFilename) => {
    const response = await fetch(url);
    if (!response.ok) {
      if (response.status === 403) {
        pushNotification({
          title: "Not authorized",
          desc: `You do not have permission to download the source code. Please contact DX support.`,
          success: false,
        });
      } else {
        pushNotification({
          title: "Error",
          desc: "Something went wrong while downloading the source code. Please try again.",
          success: false,
        });
      }
      return false;
    }

    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition") || "";
    const filenameMatch = disposition.match(/filename=(.+)/);
    const filename = filenameMatch ? filenameMatch[1] : defaultFilename;
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  };

  return {
    showAiCodeMetricsRegenerateTokenModal: false,
    showAiCodeMetricsDownloadSourceModal: false,
    aiCodeMetricsSetupDismissed: false,

    copyToken() {
      navigator.clipboard.writeText(token).then(() => {
        pushNotification({
          title: "Token copied to clipboard",
          desc: "Paste it wherever you would like.",
        });
      });
    },

    async downloadSource() {
      try {
        const success = await downloadFile(
          sourceCodeDownloadPath,
          "ai-code-metrics-source.tar.gz",
        );
        if (success) {
          this.showAiCodeMetricsDownloadSourceModal = false;
        }
      } catch (e) {
        this.showAiCodeMetricsDownloadSourceModal = false;

        pushNotification({
          title: "Error",
          desc: "Something went wrong while downloading the source code. Please try again.",
          success: false,
        });
      }
    },
  };
}
